<template>
  <div>
    <v-tabs
      v-model="active"
      fixed-tabs
      color="primary" dark
      slider-color="cyan lighten-5">
      <v-tab :key="0"> Diagnostics </v-tab>
      <v-tab :key="1"> Preparation </v-tab>
      <v-tab-item :key="0">
        <performance></performance>
      </v-tab-item>
      <v-tab-item :key="1">
        <preparation></preparation>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import Performance from './Performance'
import Preparation from './Preparation'

export default {
  name: 'Diagnostics',
  components: {
    Performance,
    Preparation
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Diagnostics/Index.vue